export default __webpack_public_path__ + "static/1.1_EN-d8fbeaf09c693cc42238ef1cbe36bf84.webp";